import { render, staticRenderFns } from "./ListFeedBlog.vue?vue&type=template&id=01511267"
import script from "./ListFeedBlog.vue?vue&type=script&lang=js"
export * from "./ListFeedBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports